<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ t(title) }}</h2>

  <mat-dialog-content>
    <p>{{ t(data.message) }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-flat-button type="button" [class.button-destructive]="isDestructiveAction" (click)="confirm()">
      {{ t(confirmText) }}
    </button>

    <button mat-button type="button" [class.button-destructive]="isDestructiveAction" (click)="cancel()">
      {{ t(cancelText) }}
    </button>
  </mat-dialog-actions>
</ng-container>
